import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AsanaLogin from '../components/featured/Asana/AsanaLogin/AsanaLogin';
import Header from '../components/shared/Header/Header';
import Sidebar from '../components/shared/Sidebar/Sidebar';
import { AsanaService } from '../service/asana.service';

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [asanaToken, setAsanaToken] = useState(localStorage.getItem('asana-token') || '');
  const isBlurred = location?.pathname === '/asana' && !asanaToken ? true : false;

  const handleAsanaUnlink = async () => {
    try {
      localStorage.removeItem('asana-token');
      localStorage.removeItem('asana-expiry');
      localStorage.removeItem('asana-cred');
    } catch (err) {
      console.error('Error unlinking Asana:', err);
    }
  };

  async function exchangeCodeForToken(code: string) {
    try {
      const payload = {
        code,
        redirect_uri: process.env.REACT_APP_ASANA_REDIRECT,
      };
      const response = await AsanaService.asanaExchangeToken(payload);
      const validate = await AsanaService.asanaValidateToken({
        'asana-token': response?.access_token || '',
      });
      console.log(validate, 'validate token');
      if (validate?.valid) {
        localStorage.removeItem('asana-fail');
        localStorage.setItem('asana-token', response?.access_token || '');
        localStorage.setItem('asana-cred', JSON.stringify(response || {}));

        const expiryTime = new Date();
        expiryTime.setSeconds(expiryTime.getSeconds() + 3600);
        localStorage.setItem('asana-expiry', expiryTime.toISOString());

        window.dispatchEvent(
          new CustomEvent('sessionStorageChange', {
            detail: { key: 'asana-token', value: response?.access_token || '' },
          }),
        );

        setAsanaToken(response?.access_token || '');

        return response;
      } else {
        handleAsanaUnlink();
      }
      window.dispatchEvent(
        new CustomEvent('asanaValidateToken', {
          detail: { key: 'asanaValidateToken', value: 'false' },
        }),
      );
    } catch (err) {
      console.log(err, 'validate err');
      localStorage.setItem('asana-fail', 'true');
      window.dispatchEvent(
        new CustomEvent('asanaValidateToken', {
          detail: { key: 'asanaValidateToken', value: 'false' },
        }),
      );
    }
  }

  useEffect(() => {
    const fetchToken = async () => {
      const token =
        !asanaToken &&
        location?.search?.split('code=')?.length > 1 &&
        (await exchangeCodeForToken(
          decodeURIComponent(location?.search?.split('code=')[1].split('&state=')[0]),
        ));

      if (token) {
        setAsanaToken(token?.access_token || '');
        navigate('/asana', { replace: true });
      }
    };
    const asanaConnecting = sessionStorage.getItem('asana-connecting');
    if (asanaConnecting === 'true') {
      sessionStorage.removeItem('asana-connecting');
      fetchToken();
    }
  }, [asanaToken, location?.search]);

  return (
    <Box
      display='flex'
      className='grid'
      sx={{ height: '100%', overflowY: 'hidden', width: '100%' }}
    >
      <Box flexBasis={{ xs: '30%', md: '210px' }}>
        <Sidebar />
      </Box>

      <Box
        flexBasis={{ xs: '100%', md: '100%' }}
        sx={{
          height: '100vh',
          width: { xs: '50%', sm: '70%', md: '85%' },
          margin: 'auto',
          overflow: 'hidden',
        }}
        paddingLeft={0}
      >
        <Header />
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <Box
            sx={{
              filter: isBlurred ? 'blur(20px)' : 'none',
              pointerEvents: isBlurred ? 'none' : 'auto',
              transition: 'filter 0.3s ease',
              position: 'relative',
            }}
          >
            <Outlet />
          </Box>
          {isBlurred && <>{location.pathname.includes('/asana') && <AsanaLogin />}</>}
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
